import BasicBuyStack, {
  BasicBuyStackProps,
} from '@/components/buy-stack/BasicBuyStack';
import '@/components/QuantitySelectorRegister';
import {safeParseOrElse} from '@/utilities/safe-parse-or-else';
import register from 'preact-custom-element';
import {z} from 'zod';

const variantsSchema = z.array(
  z.object({id: z.number(), price: z.number(), options: z.array(z.string())})
);

const Loader = (
  props: BasicBuyStackProps & {selectedVariantId?: string; variants: string}
) => {
  const {variants, selectedVariantId, ...rest} = props;
  return (
    <BasicBuyStack
      selectedVariant={
        selectedVariantId ? parseInt(selectedVariantId) : undefined
      }
      variants={safeParseOrElse(variantsSchema, [], JSON.parse(variants))}
      {...rest}
    ></BasicBuyStack>
  );
};

register(Loader, 'basic-buy-stack', []);
